import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import './shorts-pill.m.css';

export const ShortsPill = () => {
  const dispatch = useDispatch();
  const pageType = useSelector(state => get(state, ['qt', 'pageType'], ''));
  const story = useSelector(state => get(state, ['qt', 'data', 'story'], {}));
  const pbConfig = useSelector(state => get(state, ['qt', 'config', 'pagebuilder-config'], {}));
  const shortsPageEnabled = useSelector(state => get(state, ['qt', 'config', 'pagebuilder-config', 'featureToggle', 'shortsPage'], false));

  const showFloatingButton = get(pbConfig, ['shorts', 'showFloatingButton'], false);
  const floatingButtonText = get(pbConfig, ['shorts', 'floatingButtonText'], 'Shorts');
  const floatingButtonPosition = get(pbConfig, ['shorts', 'floatingButtonPosition'], 'bottom-left');
  const shortsPrefix = get(pbConfig, ['featureToggle', 'configureShortsRoute'], 'shorts').replace(/^\//, '');
  if (!showFloatingButton || (pageType === 'shorts-page' || !shortsPageEnabled)) return null;

  const handleClick = () => {
    const storySlug = get(story, ['slug'], '');
    const hasSummary = get(story, ['hasSummary'], false);
    const url = (storySlug && hasSummary)
      ? `/${shortsPrefix}/${storySlug}`
      : `/${shortsPrefix}`;
    global.app.navigateToPage(dispatch, url);
  };

  return (
<button
  styleName={`shorts-pill shorts-pill--${floatingButtonPosition}`}
  onClick={handleClick}
  aria-label={floatingButtonText}
  data-test-id="shorts-pill"
>
  <span styleName="shorts-pill-text">
    {floatingButtonText}
  </span>

  <svg
    width="19"
    height="19"
    viewBox="81 6 19 19"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    styleName="shorts-pill-icon"
  >
    <path d="M85.5417 19.7502V7.0835H95.8333V19.7502H85.5417ZM82.375 22.9168V10.2502H83.9583V21.3335H92.6667V22.9168H82.375Z" />
  </svg>
</button>
  );
};